import { render, staticRenderFns } from "./EventsListContainer.vue?vue&type=template&id=ed0bf4e8&scoped=true"
import script from "./EventsListContainer.vue?vue&type=script&lang=js"
export * from "./EventsListContainer.vue?vue&type=script&lang=js"
import style0 from "./EventsListContainer.vue?vue&type=style&index=0&id=ed0bf4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0bf4e8",
  null
  
)

export default component.exports